<template lang="pug"> 
  n-dialog(
    v-model='dialog'
    :width='800'
    transition='scale-transition'
    scrollable
  )
    v-card
      v-card-title
        v-row(no-gutters)
          v-spacer
          v-icon(
            @click='close ()'
          ) mdi-close
      v-card-text.pt-3
        v-row(no-gutters justify="center")
          h1 {{ messageRelease.title }}
        v-row.mt-5.mx-3(justify="center")
          .optimizeContent(v-html='messageRelease.description')
        v-row(no-gutters justify="center").pt-5
          v-btn(
            depressed
            width='90%'
            color='var(--bg-secondary-color)'
            dark
            @click='close ()'
          ) {{ $t('button.ok') }}
      v-card-actions
        v-checkbox(
          v-model="notShow"
          :label="$t('label.not-show-today')"
        ).mx-6


</template>
<script>
import * as c from '@/const/setTimeOutConfig'
import { news as apiNews } from '@/apis'  

export default {
  data: () => ({
    notShow:false,
    dialog:false,   
    message:[],
    notShowMessage:[],
    indexMessage:0,
  }),

  computed: {
    messageRelease () {
      return this.message[this.indexMessage] || {}
    }
  }, 
  watch: {
    notShow (val) {
      // check only dialog open
      if(!this.dialog) {
        return
      }
      const message = this.message[this.indexMessage] 
      if(val) {   
        //check not display and keep to localstorage
        this.notShowMessage.push({
          uuid:message.uuid,
          expired_timestamp:Date.now() + c.EXPIRED_MESSAGE_NOT_SHOW
        })  
      }else {
        const indexNotShowMessage = this.notShowMessage.findIndex(x=>x.uuid === message.uuid)
        this.notShowMessage.splice(indexNotShowMessage,1)
      }
    },
    dialog () {
      if(this.message.length === 0) {
        return
      } 
      if(!this.dialog) { 
        if(this.message.length-1 !== this.indexMessage){ 
          //next message 
          this.indexMessage+=1
          setTimeout(()=>this.dialog = true,c.DIALOGINDEXPERIOD)
        } else {
          //set new notShowMessage after dialog close
          localStorage.setItem('notShowMessage',JSON.stringify(this.notShowMessage))
        }
      }
    }
  },
  
  async mounted () { 
    //get message for filter from localstorage
    let notShowMessage = localStorage.getItem('notShowMessage') 
    // convert to JSON From String
    notShowMessage  = notShowMessage ? JSON.parse(notShowMessage) : []
    //filter expired data
    this.notShowMessage = notShowMessage.filter(x=>x.expired_timestamp > Date.now()) 

    //check time localstorage for alert     
    if(parseInt(localStorage.getItem('timeAlert') )< parseInt(Date.now()) 
      || localStorage.getItem('timeAlert')===null){    
      this.open()
    }  
  },

  methods : {
    async open () {  
      this.dialog = false
      let type = { type : 1 }
      const [err,data] = await apiNews.getNews(type)
      
      if(err){
        return
      } 
      //map new data with nowShowMessage Array
      const notShowMessage = this.notShowMessage
      const dataFilter = (data || []).filter(x=>!notShowMessage.find(y=>x.uuid === y.uuid))

      if(dataFilter.length===0){
        return
      }
      this.dialog = true
      this.message = dataFilter
      localStorage.setItem('timeAlert',Date.now()+c.DIALOGINDEXALERT)  
    },
    close () {   
      this.notShow = false
      this.dialog = false
    }
  }, 
}
</script>  
<style scoped>
.optimizeContent >>> img{
  width: 100%;
}
</style>